module.exports = __webpack_public_path__ + "static/img/thumb.4868e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv009/thumb.jpg
// module id = 2sa8
// module chunks = 0